var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:['timeline-item', { 'no-padding-bottom': _vm.tailHidden }]},[(!_vm.tailHidden)?_c('div',{staticClass:"tail"}):_vm._e(),_c('div',{staticClass:"node"},[_vm._v(_vm._s(_vm.dotTitle))]),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }